__turbopack_context__.v({
  "embedHtml": "PlasmicGdpr-module__fuZlVa__embedHtml",
  "freeBox": "PlasmicGdpr-module__fuZlVa__freeBox",
  "primaryButton": "PlasmicGdpr-module__fuZlVa__primaryButton",
  "root": "PlasmicGdpr-module__fuZlVa__root",
  "svg___9SKgM": "PlasmicGdpr-module__fuZlVa__svg___9SKgM",
  "svg__wVqk": "PlasmicGdpr-module__fuZlVa__svg__wVqk",
  "text": "PlasmicGdpr-module__fuZlVa__text",
});
